import { CloseOutlined, PlusOutlined } from "@ant-design/icons";
import { Form, Input, Modal, Select, TreeSelect } from "antd"
import { useForm } from "antd/es/form/Form";
import { FormInstance, FormProps } from "antd/lib";
import { useEffect, useRef } from "react";
import { icon_delelte } from "../../../../components/ExportImgFigma";
import { addColorCar } from "../../../../api/colorCar/colorCarApi";
import { ICarCompany, IRelative } from "../../../../api/selectOptions/selectOptionsApi";
import { fommatSelectOption } from "../../../../until";
import * as colorCarApi from "../../../../api/colorCar/colorCarApi"
import useThrottle from "../../../../hook/useThrottle";
import { OptionSelect_V2 } from "../../../../services/fomartUnit";
import { addIProvince, IprovinceUnit } from "../../../../api/provinces/provincesApi";
interface ModalProp {
  isOpen: boolean
  dataListNationwide: OptionSelect_V2[]
  onClose: () => void
  onSubmitFormModalAdd: (isSuccess: boolean, message?: string) => void
}

export const ModalAddProvince: React.FC<ModalProp> = ({
  isOpen, dataListNationwide,
  onClose, onSubmitFormModalAdd
}) => {
  const [form] = useForm();
  const inputRef = useRef<FormInstance>(null);
  const submitForm = () => {
    if (inputRef.current) {
      inputRef.current.submit();
    }
  };

  const onFinish: FormProps["onFinish"] = async (values) => {
    const provinceUnit = values.provinces.map((item: any) => ({
      code: item["codeprovince"],
      title: item["nameprovince"],
    }))
    confimSubmit(provinceUnit, values)
  };

  const confimSubmit = useThrottle(async (provinceUnit: IprovinceUnit[], values: any) => {
    const result = await addIProvince(values.unitId, provinceUnit)

    if (result?.status) {
      onSubmitFormModalAdd?.(true, result?.message)
    } else {
      onSubmitFormModalAdd?.(false, result?.message)
    }
  }, 2000)

  useEffect(() => {
    if (isOpen) {

    } else {
      form.resetFields()
    }
  }, [isOpen])
  return (
    <Form
      form={form}
      ref={inputRef}
      onFinish={onFinish}
      initialValues={{ remember: true }}
    >
      <Modal
        title={<div className="bg-FCFCFD d-flex justify-betweeen align-center py-4 px-6 w-full border-b-F0F0F0">
          <span className="text-base text-344054 fw-500 font-medium">Tạo mới tỉnh thành</span>
          <CloseOutlined className="text-base text-8B8B8B" onClick={onClose} />
        </div>}
        open={isOpen}
        onCancel={onClose}
        centered
        className="w-modal-477 modal-content-update-group ant-modal-size"
        closeIcon={false}
        footer={<div className="bg-FCFCFD d-flex justify-betweeen align-center py-2 px-6 w-full border-t-F0F0F0">
          <span className="text-sm text-98A2B3 cursor-pointer" onClick={onClose}>Hủy</span>
          <button className="text-white text-sm bg-096DD9 border-none shadow-btn-save rounded-2 h-8 px-15-px"
            onClick={submitForm}>
            Lưu tỉnh thành
          </button>
        </div>}
      >
        <div className="p-6 d-flex flex-column gap-18-px">
          <div className="d-flex flex-column gap-18-px">
            <div className="d-flex flex-column gap-1">
              <p className="text-sm  font-regular text-344054 d-flex gap-2 align-center">
                <span className="text-F5222D">*</span>
                Chọn đơn vị
              </p>
              <Form.Item
                name="unitId"
                rules={[{ required: true, message: 'Chọn đơn vị!' }]}
                className="m-none-form-item text-explan"
              >
                <TreeSelect
                  showSearch
                  placeholder="Chọn đơn vị"
                  allowClear
                  treeDefaultExpandAll={false}
                  treeData={dataListNationwide}
                  className="custom-tree-select "
                  filterTreeNode={(input: string, option: any) =>
                    typeof option?.label === 'string' && option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }

                />
              </Form.Item>
            </div>

            <div className="d-flex flex-column gap-3">
              <Form.List
                name="provinces"
                initialValue={[{}]}
              >
                {(fields, { add, remove }) => (
                  <div className='d-flex flex-column gap-3'>
                    {fields.map((field, i) => (
                      <div key={field.key} className="d-flex gap-3">
                        <img
                          src={icon_delelte}
                          alt=""
                          className="rounded-6-px border-f2f4f7 p-7-px bg-white cursor-pointer"
                          onClick={() => remove(i)}
                        />
                        <Form.Item
                          name={[field.name, 'codeprovince']}
                          fieldKey={[i, "codeprovince"]}
                          className="m-none-form-item text-explan"
                          rules={[{ required: true, message: 'Nhập mã tỉnh thành!' }]}
                        >
                          <Input
                            placeholder="Mã tỉnh thành"
                            className="bg-FCFCFD border-F2F4F7 text-sm rounded-2  font-regular  input-custom  h-8"
                          />
                        </Form.Item>
                        <Form.Item
                          name={[field.name, 'nameprovince']}
                          fieldKey={[i, "nameprovince"]}
                          className="m-none-form-item text-explan"
                          rules={[{ required: true, message: 'Nhập tên tỉnh thành!' }]}
                        >
                          <Input
                            placeholder="Tên tỉnh thành"
                            className="bg-FCFCFD border-F2F4F7 text-sm rounded-2  font-regular  input-custom  h-8"
                          />
                        </Form.Item>

                      </div>
                    ))}
                    <button
                      className='border-dashed-1890FF bg-white rounded-6-px  py-2 h-8 d-flex justify-center align-center gap-2 w-full'
                      onClick={add}
                    >
                      <PlusOutlined className='text-sm text-1890FF' />
                      <span className='text-sm fw-400 font-regular text-1890FF white-space-nowrap'>Thêm tỉnh thành</span>
                    </button>
                  </div>
                )}
              </Form.List>
            </div>

          </div>
        </div>
      </Modal>
    </Form>
  )
}
